// 诗词地标数据加载进度（用于全局 loading 展示）
export interface PoetryLoadProgress {
  stage: 'list' | 'neighbour' | 'retry' | 'done';
  current: number;
  total: number;
}

export enum PageMode {
  SILENT = '静默模式',
  // TRANSITIONING = '转场模式',
  HOME = '首页',
  EVENT = '大事件',
  LANDMARK_POETRY = '地标诗词',
  ROUTE_CHARACTER_LIST = '人物游线列表',
  ROUTE_THEME_LIST = '主题游线列表',
  ROUTE_CHARACTER_TRACK = '人物游线轨迹', // 人物视频模式
  ROUTE_THEME_TRACK = '主题游线轨迹',
  ROUTE_CHARACTER_TRACK_SINGLE = '人物游线轨迹单个',
  // ROUTE_THEME_TRACK_SINGLE = '主题游线轨迹单个模式',
}

export enum DigitalHumanMode {
  FULLSCREEN = '全屏',
  CORNER = '角落'
}


export enum LandmarkPoetryPlaceDetailType {
  POET = '诗人',
  POEM = '诗词',
}

export interface DriveDigitalHumanSpeak {
  text: string;
  tts: string;
  bs?: string;
  type:'xihu_insights',
}

export type ScenicDataInsights = Array<DriveDigitalHumanSpeak|{type:null}>


export interface HomePlaceInfo {
  entity_id: string;
  x: number;
  y: number;
  title: string;
  description: string;
  image?: string;
  introduce?: string;
  imageIcon?: string;
  name?: string;
  summary?: string;
  type: string[];
  biz_info?: {
    scenic:{
      data_insights:string[];
    },
    scenic_data_insights?:ScenicDataInsights;
    tour_golden_sentences?: string;
    scenic_golden_sentences?:string[]
  };
  struct_address?: any;
  ext_neighborList?: any[]
  ext_materialList?: any[]
}

export interface MaterialItem {
  cover: string;
  url: string;
  title: string;
  materialId: string;
  tagList?: string[];
}

export interface NeighborItem {
  edge: any;
  vertex: {
    author: string[];
    content: string;
    dynasty: string;
    historical_era?: string;
    entityId: string;
    name: string;
    summary: string;
  }
}

export interface LandmarkPoetryPlaceInfo {
  x: number;
  y: number;
  title: string;
  description: string;
  image?: string;
  type?: number;
  entity_id: string;
  summary?: string;
  name?: string;
  ext_neighborList: any[];
  biz_info?: any;
  short_summary?: string;
}

export interface ThemeRoutePlaceInfo {
  biz_info?: {
    tour_golden_sentences: string;
  };
  entity_id: string;
  content: string;
  left: number;
  top: number;
  name: string;
  summary: string;
  order: number;
  time_order: number;
  tour_golden_sentences?: string;
  image: string;
  type: string[];
  ext_materialList: MaterialItem[];
  ext_neighborList: NeighborItem[];
}

export interface EventCardInfo {
  entity_id: string;
  name: string;
  description: string;
  image: string;
  // time?: string;
  dynasty?: string;
  date?: string;
  scale: number;
  x: number;
  y: number;
  summary?: string;
  year?: string;
}

export interface Biz_Info {
  data: { 
    id: string, 
    name: string, 
    order: number, 
    time_order: number,
    tour_golden_sentences: string;
   }[];
}

export interface CharacterRoutePlaceInfo {
  entity_id: string;
  name: string;
  biz_info: Biz_Info;
  ext_materialList: MaterialItem[];
  image: string;
  hot: number;
  content: string;
  summary: string;
  tags: string[];
  x: number;
  y: number;
}

export interface TimeLineItem {
  content: string;
  entity_id: string;
  name: string;
  image: string;
  order: number;
  summary: string;
  time_order: number;
  size?: number;
  ext_materialList: MaterialItem[];
  ext_neighborList: NeighborItem[]
}